/**
 * 智慧无限 DK75 Single 键盘矩阵：6 行 × 17 列（与 ZHWX 协议一致）。
 * 实机 0x16 为协议坐标；LAYOUT 为公版 75% 视觉坐标，二者经 UI↔协议映射表转换。
 */

import {
  isZhwxMatrixCellOccupied,
  mergeZhwxDeviceMatrixWithFactory,
  parseZhwxMatrixCell,
  zhwxMatrixCellToUiKeyCode,
  zhwxMatrixIndex,
  ZHWX_MATRIX_COLS,
  ZHWX_MATRIX_ROWS,
} from "./zhwxDk87Layout";

/** 实机 0x16 出厂矩阵（协议坐标） */
export const ZHWX_DK75_SINGLE_FACTORY_MATRIX_BYTES = new Uint8Array([
  0x10, 0x00, 0x29, 0x10, 0x00, 0x3a, 0x10, 0x00, 0x3b, 0x10, 0x00, 0x3c, 0x10,
  0x00, 0x3d, 0x10, 0x00, 0x3e, 0x10, 0x00, 0x3f, 0x10, 0x00, 0x40, 0x10, 0x00,
  0x41, 0x10, 0x00, 0x42, 0x10, 0x00, 0x43, 0x10, 0x00, 0x44, 0x10, 0x00, 0x45,
  0x10, 0x00, 0x00, 0x10, 0x00, 0x68, 0x10, 0x00, 0x35, 0x10, 0x00, 0x1e, 0x10,
  0x00, 0x1f, 0x10, 0x00, 0x20, 0x10, 0x00, 0x21, 0x10, 0x00, 0x22, 0x10, 0x00,
  0x23, 0x10, 0x00, 0x24, 0x10, 0x00, 0x25, 0x10, 0x00, 0x26, 0x10, 0x00, 0x27,
  0x10, 0x00, 0x2d, 0x10, 0x00, 0x2e, 0x10, 0x00, 0x2a, 0x10, 0x00, 0x4a, 0x10,
  0x00, 0x2b, 0x10, 0x00, 0x14, 0x10, 0x00, 0x1a, 0x10, 0x00, 0x08, 0x10, 0x00,
  0x15, 0x10, 0x00, 0x17, 0x10, 0x00, 0x1c, 0x10, 0x00, 0x18, 0x10, 0x00, 0x0c,
  0x10, 0x00, 0x12, 0x10, 0x00, 0x13, 0x10, 0x00, 0x2f, 0x10, 0x00, 0x30, 0x10,
  0x00, 0x31, 0x10, 0x00, 0x4c, 0x10, 0x00, 0x39, 0x10, 0x00, 0x04, 0x10, 0x00,
  0x16, 0x10, 0x00, 0x07, 0x10, 0x00, 0x09, 0x10, 0x00, 0x0a, 0x10, 0x00, 0x0b,
  0x10, 0x00, 0x0d, 0x10, 0x00, 0x0e, 0x10, 0x00, 0x0f, 0x10, 0x00, 0x33, 0x10,
  0x00, 0x34, 0x10, 0x00, 0x31, 0x10, 0x00, 0x28, 0x10, 0x00, 0x4b, 0x10, 0x02,
  0x00, 0x10, 0x00, 0x64, 0x10, 0x00, 0x1d, 0x10, 0x00, 0x1b, 0x10, 0x00, 0x06,
  0x10, 0x00, 0x19, 0x10, 0x00, 0x05, 0x10, 0x00, 0x11, 0x10, 0x00, 0x10, 0x10,
  0x00, 0x36, 0x10, 0x00, 0x37, 0x10, 0x00, 0x38, 0x10, 0x20, 0x00, 0x10, 0x00,
  0x52, 0x10, 0x00, 0x4e, 0x10, 0x01, 0x00, 0x10, 0x08, 0x00, 0x10, 0x04, 0x00,
  0x10, 0x00, 0x00, 0x10, 0x00, 0x00, 0x10, 0x00, 0x2c, 0x10, 0x00, 0x00, 0x10,
  0x00, 0x00, 0x10, 0x00, 0x00, 0x10, 0x40, 0x00, 0x60, 0x01, 0x00, 0x10, 0x10,
  0x00, 0x10, 0x00, 0x50, 0x10, 0x00, 0x51, 0x10, 0x00, 0x4f, 0x00, 0x00, 0x00,
  0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
  0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
  0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
  0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
  0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
  0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
  0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
  0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
]);

/** DK75 Single 公版无 Fn 层 */
export const ZHWX_DK75_SINGLE_FN_FACTORY_MATRIX_BYTES = new Uint8Array(384);

/** 公版 75% 紧凑配列 UI 键码（虚拟键盘 / 改键展示） */
export const LAYOUT_DK75_SINGLE_KEYCODES: number[][] = [
  [41, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 0, 0, 0, 0],
  [53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 74, 0, 0],
  [43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 76, 0, 0],
  [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 40, 75, 0, 0, 0],
  [225, 0, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 82, 78, 0, 0],
  [224, 227, 226, 0, 0, 44, 0, 0, 0, 0, 230, 61697, 228, 80, 81, 79, 0],
];

/**
 * UI 虚拟键盘占位列：F12 后空槽、Shift 占位列、Space 宽键占位等。
 */
export const ZHWX_DK75_SINGLE_NON_PHYSICAL_CELLS: ReadonlyArray<
  readonly [number, number]
> = [
  [0, 13],
  [4, 1],
  [5, 6],
  [5, 7],
  [5, 8],
  [5, 9],
];

/** 协议矩阵占位列（实机 0x16 空槽 / 宽键占位） */
export const ZHWX_DK75_SINGLE_PROTOCOL_NON_PHYSICAL_CELLS: ReadonlyArray<
  readonly [number, number]
> = [
  [0, 13],
  [4, 10],
  [4, 11],
  [4, 13],
  [4, 14],
  [4, 15],
];

/**
 * 公版 UI 坐标 → 协议矩阵坐标（由实机 0x16 与 UI 键码表逐键对齐生成）。
 * 格式：[uiRow, uiCol, protocolRow, protocolCol]
 */
export const ZHWX_DK75_SINGLE_UI_TO_PROTOCOL_CELLS: ReadonlyArray<
  readonly [number, number, number, number]
> = [
  [0, 0, 0, 0],
  [0, 1, 0, 1],
  [0, 2, 0, 2],
  [0, 3, 0, 3],
  [0, 4, 0, 4],
  [0, 5, 0, 5],
  [0, 6, 0, 6],
  [0, 7, 0, 7],
  [0, 8, 0, 8],
  [0, 9, 0, 9],
  [0, 10, 0, 10],
  [0, 11, 0, 11],
  [0, 12, 0, 12],
  [1, 0, 0, 15],
  [1, 1, 0, 16],
  [1, 2, 1, 0],
  [1, 3, 1, 1],
  [1, 4, 1, 2],
  [1, 5, 1, 3],
  [1, 6, 1, 4],
  [1, 7, 1, 5],
  [1, 8, 1, 6],
  [1, 9, 1, 7],
  [1, 10, 1, 8],
  [1, 11, 1, 9],
  [1, 12, 1, 10],
  [1, 13, 1, 11],
  [1, 14, 1, 12],
  [2, 0, 1, 13],
  [2, 1, 1, 14],
  [2, 2, 1, 15],
  [2, 3, 1, 16],
  [2, 4, 2, 0],
  [2, 5, 2, 1],
  [2, 6, 2, 2],
  [2, 7, 2, 3],
  [2, 8, 2, 4],
  [2, 9, 2, 5],
  [2, 10, 2, 6],
  [2, 11, 2, 7],
  [2, 12, 2, 8],
  [2, 13, 2, 9],
  [2, 14, 2, 10],
  [3, 0, 2, 11],
  [3, 1, 2, 12],
  [3, 2, 2, 13],
  [3, 3, 2, 14],
  [3, 4, 2, 15],
  [3, 5, 2, 16],
  [3, 6, 3, 0],
  [3, 7, 3, 1],
  [3, 8, 3, 2],
  [3, 9, 3, 3],
  [3, 10, 3, 4],
  [3, 11, 3, 5],
  [3, 12, 3, 7],
  [3, 13, 3, 8],
  [4, 0, 3, 9],
  [4, 2, 3, 11],
  [4, 3, 3, 12],
  [4, 4, 3, 13],
  [4, 5, 3, 14],
  [4, 6, 3, 15],
  [4, 7, 3, 16],
  [4, 8, 4, 0],
  [4, 9, 4, 1],
  [4, 10, 4, 2],
  [4, 11, 4, 3],
  [4, 12, 4, 4],
  [4, 13, 4, 5],
  [4, 14, 4, 6],
  [5, 0, 4, 7],
  [5, 1, 4, 8],
  [5, 2, 4, 9],
  [5, 5, 4, 12],
  [5, 10, 4, 16],
  [5, 11, 5, 0],
  [5, 12, 5, 1],
  [5, 13, 5, 2],
  [5, 14, 5, 3],
  [5, 15, 5, 4],
];

export function isZhwxDk75SinglePhysicalCell(
  row: number,
  col: number
): boolean {
  return !ZHWX_DK75_SINGLE_NON_PHYSICAL_CELLS.some(
    ([r, c]) => r === row && c === col
  );
}

export function isZhwxDk75SingleProtocolPhysicalCell(
  row: number,
  col: number
): boolean {
  return !ZHWX_DK75_SINGLE_PROTOCOL_NON_PHYSICAL_CELLS.some(
    ([r, c]) => r === row && c === col
  );
}

export function isZhwxDk75SingleProtocolDisplayCell(
  row: number,
  col: number,
  cell: { type: number; codeL: number; codeH: number }
): boolean {
  return (
    isZhwxMatrixCellOccupied(cell) &&
    isZhwxDk75SingleProtocolPhysicalCell(row, col)
  );
}

/** 矩阵读写层：按协议坐标判定（供 profile.isDisplayCell） */
export function isZhwxDk75SingleDisplayCell(
  row: number,
  col: number,
  cell: { type: number; codeL: number; codeH: number }
): boolean {
  return isZhwxDk75SingleProtocolDisplayCell(row, col, cell);
}

export function isZhwxDk75SingleUiDisplayCell(
  row: number,
  col: number
): boolean {
  if (!isZhwxDk75SinglePhysicalCell(row, col)) return false;
  return (LAYOUT_DK75_SINGLE_KEYCODES[row]?.[col] ?? 0) > 0;
}

/** UI 展示坐标 → 协议矩阵坐标 */
export function resolveZhwxDk75SingleProtocolCell(
  uiRow: number,
  uiCol: number
): { row: number; col: number } | null {
  for (const [ur, uc, pr, pc] of ZHWX_DK75_SINGLE_UI_TO_PROTOCOL_CELLS) {
    if (ur === uiRow && uc === uiCol) {
      return { row: pr, col: pc };
    }
  }
  return null;
}

/** 协议矩阵坐标 → UI 展示坐标 */
export function resolveZhwxDk75SingleUiCell(
  protocolRow: number,
  protocolCol: number
): { row: number; col: number } | null {
  for (const [ur, uc, pr, pc] of ZHWX_DK75_SINGLE_UI_TO_PROTOCOL_CELLS) {
    if (pr === protocolRow && pc === protocolCol) {
      return { row: ur, col: uc };
    }
  }
  return null;
}

export function countDk75SingleUiKeysInMatrix(matrix: Uint8Array): number {
  let count = 0;
  for (let row = 0; row < ZHWX_MATRIX_ROWS; row++) {
    for (let col = 0; col < ZHWX_MATRIX_COLS; col++) {
      const cell = parseZhwxMatrixCell(matrix, zhwxMatrixIndex(row, col));
      if (!isZhwxDk75SingleProtocolDisplayCell(row, col, cell)) continue;
      if (zhwxMatrixCellToUiKeyCode(cell)) count++;
    }
  }
  return count;
}

/** 由协议矩阵生成协议坐标键码表 */
export function buildDk75SingleKeycodeGridFromMatrix(
  matrix: Uint8Array
): number[][] {
  const grid: number[][] = [];
  for (let row = 0; row < ZHWX_MATRIX_ROWS; row++) {
    const rowCodes: number[] = [];
    for (let col = 0; col < ZHWX_MATRIX_COLS; col++) {
      const cell = parseZhwxMatrixCell(matrix, zhwxMatrixIndex(row, col));
      rowCodes.push(
        isZhwxDk75SingleProtocolDisplayCell(row, col, cell)
          ? zhwxMatrixCellToUiKeyCode(cell)
          : 0
      );
    }
    grid.push(rowCodes);
  }
  return grid;
}

/** 协议矩阵 → 公版 UI 键码表（虚拟键盘 / 改键展示） */
export function buildDk75SingleUiKeycodeGridFromProtocolMatrix(
  matrix: Uint8Array
): number[][] {
  const grid: number[][] = [];
  for (let uiRow = 0; uiRow < ZHWX_MATRIX_ROWS; uiRow++) {
    const rowCodes: number[] = [];
    for (let uiCol = 0; uiCol < ZHWX_MATRIX_COLS; uiCol++) {
      if (!isZhwxDk75SingleUiDisplayCell(uiRow, uiCol)) {
        rowCodes.push(0);
        continue;
      }
      const protocolCell = resolveZhwxDk75SingleProtocolCell(uiRow, uiCol);
      if (!protocolCell) {
        rowCodes.push(LAYOUT_DK75_SINGLE_KEYCODES[uiRow]?.[uiCol] ?? 0);
        continue;
      }
      const cell = parseZhwxMatrixCell(
        matrix,
        zhwxMatrixIndex(protocolCell.row, protocolCell.col)
      );
      rowCodes.push(
        isZhwxDk75SingleProtocolDisplayCell(
          protocolCell.row,
          protocolCell.col,
          cell
        )
          ? zhwxMatrixCellToUiKeyCode(cell)
          : 0
      );
    }
    grid.push(rowCodes);
  }
  return grid;
}

/** Fn 层 UI 键码（本型号无 Fn 层） */
export const LAYOUT_DK75_SINGLE_FN_KEYCODES: number[][] =
  buildDk75SingleKeycodeGridFromMatrix(
    ZHWX_DK75_SINGLE_FN_FACTORY_MATRIX_BYTES
  );

/**
 * 虚拟键盘键宽（17 列 × 6 行，对齐公版 75% 紧凑配列）。
 */
export const TOTAL_DK75_SINGLE_KEY_WIDTHS: number[][] = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2.1, 1, 0, 0],
  [1.5, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.6, 1, 0, 0],
  [1.75, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2.4, 1, 0, 0, 0],
  [2.25, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.8, 1, 1, 0, 0],
  [1.25, 1.25, 1.25, 0, 0, 6.45, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0],
];

export const ZHWX_DK75_SINGLE_FACTORY_MIN_UI_KEYS =
  countDk75SingleUiKeysInMatrix(ZHWX_DK75_SINGLE_FACTORY_MATRIX_BYTES);

/** 协议回读矩阵是否可信（键数过少视为不完整） */
export function isZhwxDk75SingleMatrixUsable(matrix: Uint8Array): boolean {
  if (!matrix?.length) return false;
  const minFromFactory = ZHWX_DK75_SINGLE_FACTORY_MIN_UI_KEYS;
  const minAcceptable =
    minFromFactory > 0 ? Math.max(63, minFromFactory - 10) : 63;
  return countDk75SingleUiKeysInMatrix(matrix) >= minAcceptable;
}

/**
 * 主层矩阵结构是否可信（协议坐标）：
 * - F 行 col12 必须为 F12（69）
 * - 实机 packing：` 在 (0,15)
 */
export function isZhwxDk75SingleMatrixStructurallyValid(
  matrix: Uint8Array
): boolean {
  if (!matrix?.length) return false;
  const f12Cell = parseZhwxMatrixCell(matrix, zhwxMatrixIndex(0, 12));
  if (!isZhwxDk75SingleProtocolDisplayCell(0, 12, f12Cell)) return false;
  if (zhwxMatrixCellToUiKeyCode(f12Cell) !== 69) return false;
  const backtickCell = parseZhwxMatrixCell(matrix, zhwxMatrixIndex(0, 15));
  if (!isZhwxDk75SingleProtocolDisplayCell(0, 15, backtickCell)) return false;
  return zhwxMatrixCellToUiKeyCode(backtickCell) === 53;
}

/** 规范化主层读表：结构非法则用出厂快照，否则出厂为底 + 设备已改键覆盖 */
export function normalizeZhwxDk75SingleKeyMatrixTab(
  raw: Uint8Array,
  factory: Uint8Array = ZHWX_DK75_SINGLE_FACTORY_MATRIX_BYTES
): Uint8Array {
  if (!raw?.length || !isZhwxDk75SingleMatrixStructurallyValid(raw)) {
    return factory.slice();
  }
  return mergeZhwxDeviceMatrixWithFactory(raw, factory);
}

/** 宽键改键列归一：Space 主格 (5,5)，占位 (5,6~9) */
export function normalizeZhwxDk75SingleRemapCol(
  row: number,
  col: number
): number {
  if (row === 5 && col >= 6 && col <= 9) return 5;
  return col;
}
